import {OpportunityNotificationToggleService} from "./service/OpportunityNotificationToggleService";
import {NotificationToggle} from "./component/notificationToggler/notificationToggler";
import {NotificationList} from "./component/notificationList/NotificationList";
import {OpportunityNotificationToggleServiceName} from "../utils/names/serviceNames";
import {OpportunityNotificationModuleConfiguration} from "./opportunityNotificationModuleConfiguration";
import {NotificationItemComponent} from "./component/notification_item/notification-item.component";

OpportunityNotificationModuleConfiguration
    .createNewModule()
    .component('notificationsItem', NotificationItemComponent.instance)
    .component('notificationsToggle', NotificationToggle.instance)
    .component('notificationList', NotificationList.instance)
    .service(OpportunityNotificationToggleServiceName, OpportunityNotificationToggleService.instance);